export default "__VITE_ASSET__bd2314ff__"